var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { accessTokenState, userState, tokenExpirationState, refreshTokenState } from "@/views/Auth/state";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
export var useAPI = function () {
    var accessToken = useRecoilValue(accessTokenState);
    var refreshToken = useRecoilValue(refreshTokenState);
    var tokenExpiration = useRecoilValue(tokenExpirationState);
    var setAccessToken = useSetRecoilState(accessTokenState);
    var setRefreshToken = useSetRecoilState(refreshTokenState);
    var setUser = useSetRecoilState(userState);
    var setTokenExpiration = useSetRecoilState(tokenExpirationState);
    var navigate = useNavigate();
    var isRefreshing = useRef(false);
    var handleSessionExpired = function () {
        // Clear auth state
        setAccessToken("");
        setRefreshToken("");
        setUser(null);
        setTokenExpiration(null);
        // Redirect to login
        navigate("/auth/login", { replace: true });
    };
    var isTokenExpired = function () {
        if (!tokenExpiration)
            return false;
        return Date.now() >= tokenExpiration;
    };
    var shouldRefreshToken = function () {
        if (!tokenExpiration || !refreshToken)
            return false;
        // Refresh if token expires in less than 5 minutes (300000ms)
        var fiveMinutes = 5 * 60 * 1000;
        return Date.now() >= (tokenExpiration - fiveMinutes);
    };
    var refreshAccessToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, tokens, newExpiration, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isRefreshing.current)
                        return [2 /*return*/, false];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    isRefreshing.current = true;
                    return [4 /*yield*/, fetch(process.env.MIX_API_URL + "/api/v1/auth/cognito/token/refresh", {
                            method: "POST",
                            body: JSON.stringify({ refresh_token: refreshToken }),
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Token refresh failed");
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    tokens = data.data.tokens;
                    // Update tokens with new values
                    if (tokens.access_token) {
                        setAccessToken(tokens.access_token);
                    }
                    // Calculate new expiration time
                    if (tokens.expires_in) {
                        newExpiration = Date.now() + (tokens.expires_in * 1000);
                        setTokenExpiration(newExpiration);
                    }
                    isRefreshing.current = false;
                    return [2 /*return*/, true];
                case 4:
                    error_1 = _a.sent();
                    isRefreshing.current = false;
                    console.error("Failed to refresh token:", error_1);
                    handleSessionExpired();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return function (endpoint_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([endpoint_1], args_1, true), void 0, function (endpoint, method, body, sendFormData) {
            var isAuthEndpoint, refreshed, response;
            if (method === void 0) { method = "GET"; }
            if (body === void 0) { body = {}; }
            if (sendFormData === void 0) { sendFormData = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isAuthEndpoint = endpoint.includes("/auth/login") || endpoint.includes("/auth/cognito");
                        if (!!isAuthEndpoint) return [3 /*break*/, 2];
                        // Check if token is expired
                        if (isTokenExpired()) {
                            handleSessionExpired();
                            throw new Error("Session expired. Please login again.");
                        }
                        if (!shouldRefreshToken()) return [3 /*break*/, 2];
                        return [4 /*yield*/, refreshAccessToken()];
                    case 1:
                        refreshed = _a.sent();
                        if (!refreshed) {
                            throw new Error("Failed to refresh session.");
                        }
                        _a.label = 2;
                    case 2:
                        if (!sendFormData) return [3 /*break*/, 4];
                        // If body type is not FormData, return an error
                        if (!(body instanceof FormData)) {
                            throw new Error("Body must be of type FormData");
                        }
                        return [4 /*yield*/, fetch(process.env.MIX_API_URL + "/api/v1" + endpoint, {
                                method: method,
                                body: body,
                                headers: {
                                    Accept: "application/json",
                                    Authorization: "Bearer ".concat(accessToken),
                                },
                            })];
                    case 3:
                        response = _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, fetch(process.env.MIX_API_URL + "/api/v1" + endpoint, {
                            method: method,
                            body: method !== "GET" ? JSON.stringify(body) : undefined,
                            headers: {
                                Accept: "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                                "Content-Type": "application/json",
                            },
                        })];
                    case 5:
                        response = _a.sent();
                        _a.label = 6;
                    case 6:
                        // Check if session expired (401 Unauthorized)
                        if (response.status === 401 && endpoint !== "/auth/login") {
                            handleSessionExpired();
                            throw new Error("Session expired. Please login again.");
                        }
                        // Redirect to maintenance page if system is under maintenance (503)
                        if (response.status === 503) {
                            window.location.replace("/");
                            throw new Error("System is under maintenance.");
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
};
